import { Genres, SocialId } from '@beat-venues/common-types';
import { ICONS } from '../';

export const getIconName = (iconName: SocialId | Genres): string => {
    const icon = ICONS.find((item) =>
        item.toLowerCase().includes(iconName.toLowerCase())
    );
    if (!icon) {
        throw new Error('Unknown icon');
    }
    return icon;
};
